/* Copyright (c) 2017 VMware, Inc. All rights reserved. VMware Confidential */
import { Injectable, Renderer2 } from "@angular/core";
import { Observable, Subject } from "rxjs";

// @formatter:off
@Injectable({
    providedIn: "root"
})
// @formatter:on
export class WindowService {

    private _windowResized: Subject<void> = new Subject<void>();
    public onWindowResized: Observable<void> = this._windowResized.asObservable();

    public initialize(renderer: Renderer2): void {
        renderer.listen(window, "resize", () => this._windowResized.next());
    }
}
